import { C as Component } from "./component-DqhvLgtR.js";
import { D as DialogOpenEvent, d as DialogCloseEvent } from "./events-C4hlH4zR.js";
import { d as defineCustomElement } from "./utilities-DuXQiAqj.js";
class DialogComponent extends Component {
  // ✅ 1. Nutzung des Refs-Systems der Base Class
  requiredRefs = ["dialog"];
  // Statischer Counter, der von allen Instanzen geteilt wird (statt window.__dialogOpenCount)
  static openCount = 0;
  // Scroll-Position beim ersten Lock gemerkt, um sie beim Unlock wiederherzustellen
  static savedScrollY = 0;
  // Lock-Status dieser Instanz — macht #handleScrollLock idempotent, damit
  // Cancel-Close-Reopen den geteilten openCount nicht desynchronisiert.
  #isLocked = false;
  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener("click", this.#handleBackdropClick);
    this.refs.dialog.addEventListener("cancel", this.#handleCancel);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.dialog.removeEventListener("click", this.#handleBackdropClick);
    this.refs.dialog.removeEventListener("cancel", this.#handleCancel);
    if (this.refs.dialog.open) {
      this.#handleScrollLock(false);
    }
  }
  #handleBackdropClick = (event) => {
    if (event.target === this.refs.dialog) {
      this.closeDialog();
    }
  };
  // Prevent native ESC close and route through closeDialog() for proper scroll unlock
  #handleCancel = (event) => {
    event.preventDefault();
    this.closeDialog();
  };
  /**
   * Verwaltet den Scroll-Lock sicher über mehrere Dialoge hinweg
   * @param {boolean} lock
   */
  #handleScrollLock(lock) {
    if (lock === this.#isLocked) {
      return;
    }
    this.#isLocked = lock;
    const body = document.body;
    if (lock) {
      if (DialogComponent.openCount === 0) {
        DialogComponent.savedScrollY = window.scrollY;
        body.style.position = "fixed";
        body.style.top = `-${DialogComponent.savedScrollY}px`;
        body.style.width = "100%";
        body.style.overflow = "hidden";
      }
      DialogComponent.openCount++;
    } else {
      DialogComponent.openCount--;
      if (DialogComponent.openCount <= 0) {
        DialogComponent.openCount = 0;
        body.style.position = "";
        body.style.top = "";
        body.style.width = "";
        body.style.overflow = "";
        window.scrollTo({
          top: DialogComponent.savedScrollY,
          left: 0,
          behavior: "instant",
        });
      }
    }
  }
  showDialog() {
    if (this.refs.dialog.open) {
      this.refs.dialog.classList.remove("dialog-closing");
      this.#handleScrollLock(true);
      return;
    }
    this.refs.dialog.classList.remove("dialog-closing");
    this.refs.dialog.showModal();
    this.#handleScrollLock(true);
    this.dispatchEvent(new DialogOpenEvent());
  }
  closeDialog() {
    if (!this.refs.dialog.open) {
      return Promise.resolve();
    }
    this.refs.dialog.classList.add("dialog-closing");
    this.#handleScrollLock(false);
    return new Promise((resolve) => {
      this.refs.dialog.addEventListener(
        "animationend",
        () => {
          this.refs.dialog.close();
          this.refs.dialog.classList.remove("dialog-closing");
          this.dispatchEvent(new DialogCloseEvent());
          resolve();
        },
        { once: true }
      );
    });
  }
  toggleDialog() {
    if (this.refs.dialog.open) {
      return this.closeDialog();
    }
    this.showDialog();
    return Promise.resolve();
  }
}
defineCustomElement("dialog-component", DialogComponent);
const dialog = /* @__PURE__ */ Object.freeze(
  /* @__PURE__ */ Object.defineProperty(
    {
      __proto__: null,
      DialogComponent,
    },
    Symbol.toStringTag,
    { value: "Module" }
  )
);
export { DialogComponent as D, dialog as d };
